/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fila-no-ajustable[_ngcontent-%COMP%]{background-color:#ffe0e0!important}.estado-despachado[_ngcontent-%COMP%]{background-color:#0ba731!important;color:#fff}.estado-liquidado[_ngcontent-%COMP%]{background-color:#fb3!important;color:#fff}"];
export { styles as styles };
